import React, { useMemo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import UploadDocumentItem from './UploadDocumentItem'
import { getAmbassadorDocumentsById } from 'Reducers/Ambassador/actions'
import { getDocumentTypes } from 'Reducers/Document/actions'
import {
  createAmbassadorDocumentsById,
  uploadAmbassadorDocument,
} from 'Reducers/Ambassador/actions'
import {
  ambassadorDocumentsPreviewSelector,
  filterDocumentTypesInThisCountrySelector,
  updateData,
} from './utils'

const AmbassadorUploadDocumentsWrapper = ({ ambassadorId, countryCode }) => {
  const [uploadDocumentsData, setUploadDocumentsData] = useState([])
  const dispatch = useDispatch()

  const selectFilterDocumentTypesInThisCountry = useMemo(
    filterDocumentTypesInThisCountrySelector,
    [],
  )
  const selectAmbassadorDocumentsPreview = useMemo(
    ambassadorDocumentsPreviewSelector,
    [],
  )

  const documentTypesList = useSelector(state =>
    selectFilterDocumentTypesInThisCountry(state, countryCode),
  )
  const ambassadorDocumentsPreview = useSelector(
    selectAmbassadorDocumentsPreview,
  )

  useEffect(() => {
    dispatch(getAmbassadorDocumentsById(ambassadorId))
    dispatch(getDocumentTypes())

    return () => window.location.reload()
  }, [])

  useEffect(() => {
    if (!documentTypesList.length) return
    const startUploadDocumentsData = documentTypesList.map(documentType => ({
      ...documentType,
      documentPreview: ambassadorDocumentsPreview[documentType.id],
      loading: false,
      isDisableDropzone: false,
    }))
    setUploadDocumentsData(startUploadDocumentsData)
  }, [documentTypesList, ambassadorDocumentsPreview])

  const handleUploadDocument = ({ file, typeId }) => {
    setUploadDocumentsData(currentData =>
      updateData({
        currentData,
        typeId,
        currentItemNewData: { loading: true },
        otherItemsNewData: { isDisableDropzone: true },
      }),
    )

    const callbacks = {
      onSuccess: fileURL => {
        setUploadDocumentsData(currentData =>
          updateData({
            currentData,
            typeId,
            currentItemNewData: { loading: false },
          }),
        )
        onSaveDocument({ typeId, fileURL })
      },
    }
    dispatch(uploadAmbassadorDocument(ambassadorId, file[0], callbacks))
  }

  const onSaveDocument = ({ typeId, fileURL }) => {
    const payload = {
      type: typeId,
      url: fileURL,
    }

    const callbacks = {
      onSuccess: () => {
        setUploadDocumentsData(currentData =>
          updateData({
            currentData,
            typeId,
            otherItemsNewData: { isDisableDropzone: false },
          }),
        )
        dispatch(getAmbassadorDocumentsById(ambassadorId))
      },
    }
    dispatch(createAmbassadorDocumentsById(ambassadorId, payload, callbacks))
  }

  return (
    <div>
      {uploadDocumentsData && uploadDocumentsData.length > 0
        ? uploadDocumentsData.map(itemData => (
            <UploadDocumentItem
              key={itemData.id}
              itemData={itemData}
              ambassadorId={ambassadorId}
              onUploadDocument={handleUploadDocument}
            />
          ))
        : null}
    </div>
  )
}

export default AmbassadorUploadDocumentsWrapper



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/UploadDocuments/UploadDocumentsForm/index.js